import React, { useState, useEffect, useMemo } from 'react';
import { Button, Form, Row, Col, Spinner, Badge } from 'react-bootstrap';
import { FaPlus, FaTrash, FaEdit, FaTimes, FaSave, FaListUl } from 'react-icons/fa';
import { getAdminLookups, saveAdminLookup, deleteAdminLookup } from '../../services/adminApi';
import ReusableAdminTable from './ReusableAdminTable'; // 👈 important
import './AdminLookupPage.css';

const AdminLookupPage = () => {

    const [lookups, setLookups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [view, setView] = useState('list');

    const [groupName, setGroupName] = useState('');
    const [items, setItems] = useState([{ value: '', label: '' }]);
    const [editingId, setEditingId] = useState(null);

    // 🔥 FETCH
    const fetchLookups = async () => {
        setLoading(true);
        try {
            const res = await getAdminLookups();
            setLookups(res.data);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchLookups();
    }, []);

    // 🔧 FORM LOGIC
    const handleAddItem = () => setItems([...items, { value: '', label: '' }]);

    const handleRemoveItem = (index) => {
        setItems(items.filter((_, i) => i !== index));
    };

    const handleItemChange = (index, field, val) => {
        const newItems = [...items];
        newItems[index][field] = val;
        setItems(newItems);
    };

    const handleCancel = () => {
        setGroupName('');
        setItems([{ value: '', label: '' }]);
        setEditingId(null);
        setView('list');
    };

    const handleSave = async () => {
        if (!groupName) return alert("Group Name is required");

        try {
            await saveAdminLookup({
                lookupGroup: groupName,
                dataList: items
            });

            handleCancel();
            fetchLookups();

        } catch (e) {
            alert("Save failed");
        }
    };

    const handleEdit = (lk) => {
        setGroupName(lk.lookupGroup);
        setItems(
            lk.lookupValue.data.map(d => ({
                value: d.lookupValue,
                label: d.lookupLabel
            }))
        );
        setEditingId(lk.id);
        setView('form');
    };

    // 📊 TABLE COLUMNS
    const columns = useMemo(() => [
        {
            accessorKey: 'lookupGroup',
            header: 'Group Identity',
            cell: (info) => (
                <span className="lookup-label text-white">
                    {info.getValue()}
                </span>
            )
        },
        {
            accessorKey: 'lookupValue',
            header: 'Values Count',
            cell: (info) => (
                <Badge bg="dark" className="border border-secondary px-3 py-2">
                    {info.row.original.lookupValue?.total || 0} Items
                </Badge>
            )
        },
        {
            id: 'actions',
            header: 'Actions',
            cell: (info) => {
                const lk = info.row.original;

                return (
                    <div className="d-flex justify-content-end gap-2">

                        <button
                            className="btn-action-icon"
                            onClick={() => handleEdit(lk)}
                        >
                            <FaEdit size={14}/>
                        </button>

                        <button
                            className="btn-action-icon"
                            onClick={async () => {
                                if(window.confirm(`Delete ${lk.lookupGroup}?`)) {
                                    await deleteAdminLookup(lk.lookupGroup);
                                    fetchLookups();
                                }
                            }}
                        >
                            <FaTrash size={14}/>
                        </button>

                    </div>
                );
            }
        }
    ], []);

    return (
        <div className="admin-lookup-page animate-fade-in">

            {/* HEADER */}
            {/* <div className="d-flex justify-content-between align-items-center mb-4 p-2">
                <div>
                    <h2 className="page-title">
                        {view === 'list'
                            ? 'Lookup Registry'
                            : (editingId ? 'Edit Lookup Group' : 'Add New Lookup Group')}
                    </h2>

                    <p className="text-muted small mb-0">
                        Define and manage system-wide dropdown constants.
                    </p>
                </div>

                {view === 'list' ? (
                    <Button className="btn-premium-save" onClick={() => setView('form')}>
                        <FaPlus className="me-2" /> NEW LOOKUP
                    </Button>
                ) : (
                    <Button className="btn-premium-cancel" onClick={handleCancel}>
                        <FaTimes className="me-2" /> CANCEL
                    </Button>
                )}
            </div> */}

            {/* <div className="d-flex justify-content-between align-items-center mb-4 p-2">
    <div>
        <h2 className="page-title">
            {view === 'list'
                ? 'Lookup Registry'
                : (editingId ? 'Edit Lookup Group' : 'Add New Lookup Group')}
        </h2>

        <p className="text-muted small mb-0">
            Define and manage system-wide dropdown constants.
        </p>
    </div>

    {view !== 'list' && (
        <Button className="btn-premium-cancel" onClick={handleCancel}>
            <FaTimes className="me-2" /> CANCEL
        </Button>
    )}
</div> */}

            <div className="lookup-card-main">

                {view === 'list' ? (

                    loading ? (
                        <div className="text-center py-5">
                            <Spinner variant="danger" />
                        </div>
                    ) : (

                        <ReusableAdminTable
                            data={lookups}
                            columns={columns}
                            onAddNew={() => setView('form')}
                             addNewButtonText="New Lookup"
                            isLoading={loading}
                             title={
                                view === 'list'
                                    ? 'Lookup Registry'
                                    : (editingId ? 'Edit Lookup Group' : 'Add New Lookup Group')
                            }
                            />

                    )

                ) : (

                    /* FORM */
                    <div className="animate-fade-in">

                        <Row className="mb-4">
                            <Col md={6}>
                                <Form.Label className="label-premium">
                                    Group Identifier (Slug)
                                </Form.Label>

                                <Form.Control
                                    className="input-dark-lookup"
                                    value={groupName}
                                    onChange={(e) => setGroupName(e.target.value)}
                                    placeholder="e.g. skinType"
                                    disabled={!!editingId}
                                />

                                <small className="text-muted mt-1 d-block">
                                    Used internally to fetch these options.
                                </small>
                            </Col>
                        </Row>

                        <h6 className="label-premium mt-5 mb-3">
                            <FaListUl className="me-2"/> Row Entries
                        </h6>

                        <div className="items-container mb-4">

                            {items.map((item, index) => (
                                <Row key={index} className="mb-3 g-2 align-items-center">

                                    <Col md={5}>
                                        <Form.Control
                                            className="input-dark-lookup"
                                            placeholder="Value"
                                            value={item.value}
                                            onChange={(e) => handleItemChange(index, 'value', e.target.value)}
                                        />
                                    </Col>

                                    <Col md={5}>
                                        <Form.Control
                                            className="input-dark-lookup"
                                            placeholder="Label"
                                            value={item.label}
                                            onChange={(e) => handleItemChange(index, 'label', e.target.value)}
                                        />
                                    </Col>

                                    <Col md={2}>
                                        {items.length > 1 && (
                                            <Button
                                                variant="link"
                                                className="text-danger p-0"
                                                onClick={() => handleRemoveItem(index)}
                                            >
                                                <FaTrash />
                                            </Button>
                                        )}
                                    </Col>

                                </Row>
                            ))}

                            <Button
                                variant="link"
                                className="text-info p-0 mt-2"
                                onClick={handleAddItem}
                            >
                                <FaPlus className="me-1" /> Add another row
                            </Button>

                        </div>

                        <div className="d-flex justify-content-between align-items-center border-top border-secondary pt-4 mt-5">

                            <Button className="btn-premium-cancel" onClick={handleCancel}>
                                DISCARD
                            </Button>

                            <Button className="btn-premium-save" onClick={handleSave}>
                                <FaSave className="me-2" /> SAVE
                            </Button>

                        </div>

                    </div>

                )}

            </div>
        </div>
    );
};

export default AdminLookupPage;